import AuthService from '@/services/AuthService'
import { LOGIN, LOGOUT, NOT_AUTHENTICATED, RECOVER_PASSWORD, RECOVER_PASSWORD_CODE } from '../actions.type'
import { SET_AUTH, PURGE_AUTH } from '../mutations.type'
import router from '@/router'

const state = {
    isAuthenticated: !!localStorage.getItem('token'),
    user: JSON.parse(localStorage.getItem('user')) || {}
}

const getters = {
    isAuthenticated: state => state.isAuthenticated,
    isApprover: state => state.user.role == 2,
    isAdmin: state => state.user.role == 1
}

const actions = {
    [LOGIN]: ({ commit }, { email, password }) => {
        return new Promise((resolve, reject) => {
            AuthService.userLogin(email, password)
                .then(resp => {
                    if (resp.status === 200) {
                        if (resp.data && resp.data.data && !resp.data.data.error) {
                            if (resp.data.data) {
                                commit(SET_AUTH, resp.data.data);
                                resolve()
                            } else {
                                reject('No authentication token returned. Please try again later.')
                            }
                        } else {
                            reject(resp.data.error)
                        }
                    } else if (resp.data.error) {
                        reject(resp.data.error)
                    }
                    else {
                        reject('Unknown error')
                    }
                }).catch(err => {
                    reject(err.response.data.error)
                })
            })
    },
    [LOGOUT]: ({ commit }) => {
        commit(PURGE_AUTH)
    },
    [NOT_AUTHENTICATED]: ({ dispatch }) => {
        dispatch(LOGOUT)
        router.push('/login')
    },
    [RECOVER_PASSWORD]: ({ commit }, email) => {
        return new Promise((resolve, reject) => {
            AuthService.recoverPassword(email)
            .then(resp => {
                if (resp.data) {
                    if (resp.data.error) {
                        reject(resp.data.error)
                    } else if (resp.data.data) {
                        resolve()
                    }
                    else {
                        reject('NO DATA')
                    }
                }
                else {
                    reject('NO RESPONSE')
                    commit();
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    [RECOVER_PASSWORD_CODE]: ({ commit }, { code, password }) => {
        return new Promise((resolve, reject) => {
            AuthService.recoverPasswordCode(code, password)
            .then(resp => {
                if (resp.data) {
                    if (resp.data.error) {
                        reject(resp.data.error)
                    } 
                    else {
                        resolve()
                    }
                }
                else {
                    reject('NO RESPONSE')
                    commit();
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    }
}

const mutations = {
    [SET_AUTH]: (state, {token, user}) => {

        state.isAuthenticated = true;
        localStorage.setItem('token', token);

        state.user = {
            name: user.name,
            email: user.email,
            role: user.user_type_id,
            id: user.id
        }
        localStorage.setItem('user', JSON.stringify(state.user))
    },
    [PURGE_AUTH]: state => {
        state.isAuthenticated = false;
        localStorage.removeItem('token')
        state.user={}
        localStorage.removeItem('user')
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}